import React, { useState, useEffect } from 'react'
import { ActionButton } from '@emerald-works-nova/components'
import { useEvent } from '@emerald-works/react-event-bus-client'
import { Box, Divider, Grid, Switch, Typography, useTheme } from '@mui/material'
import { useDispatch } from 'react-redux'
import { BannerStatic } from '../../../components'
import { TenantEditSlice } from '../../../reducers'
import { useStyles } from '../features-tab/style'
import { useTenantFormContext } from '../tenant-form-context'
import { Controller } from 'react-hook-form'

const MSBSettings = () => {
  const classes = useStyles()
  const { spacing } = useTheme()
  const dispatch = useDispatch()
  const { tenant, isEdit, form } = useTenantFormContext()
  const { watch, setValue } = form
  const [isLoading, setIsLoading] = useState(false)
  const features = watch('features')
  const msb = features?.msb ?? false
  const accelerate = features?.accelerate?.enabled ?? false

  const handleSwitch = () => {
    setValue('features.msb', !msb)
  }

  useEffect(() => {
    if (!isEdit) {
      setValue('features.msb', false)
      return
    }
    const hasMSB = tenant?.features?.msb
    setValue('features.msb', hasMSB)
  }, [tenant, isEdit, setValue])

  const [tenantUpdate] = useEvent([
    {
      eventName: 'tenantUpdate',
      onSuccess: (tenant) => {
        BannerStatic.show({ label: 'MSB configuration updated' })
        setIsLoading(false)
        dispatch(TenantEditSlice.actions.updateTenantFeatures(tenant.features))
      },
      onError: () => {
        BannerStatic.show({
          label: 'There was an error saving the MSB feature configuration',
          isError: true
        })
        setIsLoading(false)
      }
    }
  ])

  const handleSave = () => {
    if (accelerate && !msb) {
      return BannerStatic.show({
        label: 'You need to disable Accelerate to turn off Manager Skills Builder',
        isWarning: true
      })
    }

    tenantUpdate.trigger({
      pk: tenant.pk,
      features: {
        ...tenant.features,
        msb: msb
      }
    })
    setIsLoading(true)
  }

  return (
    <Grid container className={classes.featContainer}>
      <Grid item xs={12}>
        <Box
          border={1}
          borderRadius='undefinedpx'
          borderColor='#E0E0E0'
          display='flex'
          style={{
            justifyContent: 'space-between',
            flexDirection: 'column',
            padding: spacing(1, 4)
          }}
        >
          <Box display='flex' flexDirection='row'>
            <Typography variant='body2' style={{ marginTop: spacing(3.5) }}>
              Manager Skills Builder
            </Typography>
            <Box
              display='flex'
              style={{
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                flex: 1,
                padding: spacing(1)
              }}
            >
              <Box style={{ padding: spacing(2, 0.5) }}>
                <Controller
                  name='features.msb'
                  control={form.control}
                  render={({ field }) =>
                    <Switch
                      color='primary'
                      checked={!!field.value}
                      onChange={handleSwitch}
                      disabled={isLoading}
                      data-test='msb-product-toggle'
                      {...field}
                    />}
                />
              </Box>
            </Box>
          </Box>

          {isEdit && (
            <Box>
              <Divider style={{ marginBottom: spacing(1) }} />

              <Box display='flex' justifyContent='flex-end' mt={1} mb={1}>
                <ActionButton
                  onClick={handleSave}
                  disabled={isLoading}
                  variant='primary'
                  dataTest='msb-save-button'
                  style={{ height: 'min-content' }}
                > Save
                </ActionButton>
              </Box>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  )
}

export default MSBSettings
